<template>
    <div style=" z-index: 666; clear: both;">
        <!-- <div class="fixadd" v-if="showInstallButton" @click="installApp">添加到桌面</div> -->
        <BackTop :bottom="100" style="z-index: 9999;" :right="25"></BackTop>  
        <div class="copybox">
            <div class="copydebox">
                <div class="fulogo"><img :src="ffflogo"/></div>
                <div class="copymain">
                    <p>PKzoo.com，致力于测评推荐收录分享发现一些优秀的的网站/应用。</p>
    <p>大千世界犹如浩瀚的动物园，每个网站/应用犹如这世界食物链里的生物。动物园里有才华横溢的设计狮，富有创造力的程序猿，用心市场洞察的产品汪，还有一群群牛马等...他们都在各自领域闪耀着光芒。PKzoo希望通过共同测评、探索共同发现的分享方式，能使缺乏名气流量但又优秀有价值+"美味"的应用浮现在用户面前，收录具有实用价值的网站/应用。</p>
                </div>
            </div>

            <div class="kfewm">
                <h3>关于PKZOO</h3>
                <br/>
                <p @click="gocontact">关于我们</p>
                <br/>
                <p @click="gocontact">联系我们</p>
                <!-- <dl>
                    <dt><img :src="ewm"/></dt>
                    <dd>客服微信</dd>
                </dl>     -->
            </div>

            <div class="kfewm">
                <!-- <h3>关于PKZOO</h3>
                <br/>
                <p>关于我们</p>
                <p>联系我们</p> -->
                <dl>
                    <dt><img :src="ewm"/></dt>
                    <dd style="text-align: center;">客服微信</dd>
                </dl>    
            </div>
            <div class="copylogo"> 
                <div class="shoucangbox">按 <span>Ctrl</span> + <span>D</span> 一键收藏</div>
                <img :src="fulogo"/>
                <div class="solgnbox">致力于成为最好的测评应用导航</div>
            </div>
        </div>
        <div class="copyright"><div class="copyrightbox">
            
            <span style="float: left;">COPYRIGHT © 2026 PKzoo.com 版权所有 闽ICP备2026012894号-1 &nbsp;&nbsp;&nbsp;</span><a target="_blank"  style="float: left; padding-top: 5px;" title="51la网站统计" href="https://v6.51.la/land/3Pru3doVWv30ROYC"><img src="https://sdk.51.la/icon/3-1.png"></a></div></div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                downsoulan: require("@/assets/images/downsolan.jpg"),
                fulogo: require("@/assets/images/fulo.png"),
                ffflogo: require("@/assets/images/ffflogo.png"),
                ewm: require("@/assets/images/ewm.jpg"),
                deferredPrompt: null, // 存储 beforeinstallprompt 事件
                showInstallButton: false // 控制安装按钮的显示
            }
        },
       mounted() {

        window.addEventListener('beforeinstallprompt', (e) => {
            // 阻止浏览器默认的安装提示UI（如地址栏图标）
            e.preventDefault();
            // 存储事件对象，供后续调用
            this.deferredPrompt = e;
            // 显示自定义的安装按钮
            this.showInstallButton = true;
        });
       },
       methods: {
        gocontact(){
            this.$router.push({
                name:'contact'
             })
        },
        async installApp() {
            if (!this.deferredPrompt) {
            console.log('安装提示事件不存在，可能PWA已安装或不符合条件');
            return;
            }
            // 显示安装提示框
            this.deferredPrompt.prompt();
            // 等待用户对提示框做出操作（点击“安装”或“取消”）
            const { outcome } = await this.deferredPrompt.userChoice;
            console.log(`用户选择了: ${outcome}`);
            // 清除存储的事件对象，该对象只能使用一次
            this.deferredPrompt = null;
            // 隐藏安装按钮，避免重复操作
            this.showInstallButton = false;
        }
      }

    }
</script>

<style lang="scss" scoped>

.fixadd{ position: fixed; right: 20px; bottom: 200px; width: 50px; height: 50px; background: #333; border-radius: 25px; text-align: center; z-index: 999; cursor: pointer;}
.copybox{ height: 350px; background:#26282c; display: flex; justify-content: space-between; position: relative; z-index: 666;}
.fulogo{ padding-top: 50px; padding-bottom: 10px;}
.fulogo img{ width:280px;}
.copyright{ background: #181818; height: 50px; line-height: 50px; overflow: hidden;
    .copyrightbox{ padding-left:235px; color: #fff; padding-top:3px; font-size: 13px;}
}
.copydebox{ padding-left: 100px;}
.copydebox .copymain{ width: 500px; font-size: 14px; color: #ddd;}

.copylogo{ padding-right:100px; padding-top: 50px;}
.copylogo img{ width: 250px;}
.copylogo .solgnbox{ padding-top: 10px; color: #fff; font-size: 17px; width: 250px; text-align: center; font-weight: bold;}
.kfewm{ text-align: left; color:#ddd; font-size: 16px; padding-top:120px; }
.kfewm img{ width: 130px;}
.kfewm p{
    cursor: pointer;
}

.shoucangbox{ color: #fff;margin-bottom: 50px; width: 250px; text-align: center;font-size: 16px; background: #111;border-radius: 10px; padding: 10px 0;}
.shoucangbox span{ color: #333; font-size: 16px; font-weight: bold; background: #fff; display: inline-block; padding: 5px 10px;font-size: 16px; border-radius: 5px; margin-left: 5px; margin-right: 5px;}

</style>


// WEBPACK FOOTER //
// src/components/publish/downfooter.vue